// Tiny pub/sub so the shared data-layer functions (create/update/delete
// transaction) can drive ONE global loading overlay — instead of every one of
// the ~46 forms wiring its own spinner. Counter-based, so nested/concurrent
// operations keep the overlay up until the LAST one finishes.

let count = 0;
let label = '';
const listeners = new Set();

const emit = () => {
  const snapshot = { active: count > 0, label };
  listeners.forEach(fn => { try { fn(snapshot); } catch { /* ignore listener errors */ } });
};

/** Show the overlay with a message. Pair every call with exactly one endBusy(). */
export const beginBusy = (msg = 'Working…') => { count += 1; label = msg; emit(); };

/** Hide one level of busy. Overlay disappears when the counter returns to 0. */
export const endBusy = () => { count = Math.max(0, count - 1); if (count === 0) label = ''; emit(); };

/** Subscribe a React setter; returns an unsubscribe fn. Fires immediately with current state. */
export const subscribeBusy = (fn) => {
  listeners.add(fn);
  fn({ active: count > 0, label });
  return () => listeners.delete(fn);
};
